import React, { Component } from 'react';
import { getFolders, getFolderPresentation } from '../../actions';
import classNames from 'classnames';
import PropTypes from 'prop-types'

class SelectFieldFolder extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      folders: [],
    }
  }
  
  
  async componentDidMount() {
    try {
      let folders = await getFolders();
      this.setState({
        folders: folders,
      });
    } catch (error) {
      
    }
  }

  render() {
    const {input, type, disabled, meta: { touched, error }, placeholder, label, } = this.props;
    const { presentations, folders } = this.state;
    const {formatMessage} = this.context;
    return (
      <div>
        <div className={classNames("create-dialog-form__group create-dialog-form__group--indent-bottom", {disabled})}>
          <label>{formatMessage('labelInputFolder')}</label>
          <select {...input} disabled={disabled} className="create-dialog-form__control" >
            <option></option>
            {folders.map(option => <option key={'folder-' + option.id} value={option.id}>{option.title}</option>)}
          </select>
          {touched && ((error && <span style={{color: 'red'}}>{error}</span>))}
        </div>
      </div>
    );
  }
}

export default SelectFieldFolder;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmPresentation/components/FormContent/SelectFieldFolder.js